import { ReactComponent as ArrowGoIcon } from 'assets/images/elearning/navigation/arrow_go_icon.svg';
import { ReactComponent as TickIcon } from 'assets/images/elearning/navigation/tick_icon.svg';
import clsx from 'clsx';
import { FC } from 'react';
import { Link, useMatch } from 'react-router-dom';
import { PATHS } from 'constants/routes';
import { Topic } from 'types/elearning';
import cls from './list-item.module.scss';

interface IProps {
    topic: Topic & { topics?: Topic[]};
    path: string;
    isGreen?: boolean;
    prefixPath?: string;
}

export const ListItem: FC<IProps> = ({ topic, path, isGreen, prefixPath }) => {
    
    const basePrefix = prefixPath
        ? prefixPath.startsWith(PATHS.ONLINE_TRAININGS)
            ? prefixPath
            : `${PATHS.ONLINE_TRAININGS}/${prefixPath}`
        : PATHS.ONLINE_TRAININGS;

    const rawLink = path === 'q'
        ? `${basePrefix}/${path}/quiz`
        : `${basePrefix}/${path}/${topic?.topics[0]?.path}`;

    const linkToElement = rawLink?.startsWith('/') ? rawLink : `/${rawLink?.replace(/^\/+/, '')}`;
    
    return (
        <li className={cls.item}>
            <div className={cls.line}></div>
            <Link
                className={clsx(cls.itemLink, {
                    [cls.itemLinkActive]: useMatch(
                        linkToElement
                    ),
                    [cls.itemLinkBlocked]: !topic?.is_available,
                })}
                to={linkToElement}
            >
                <div className={cls.itemTopicWrapper}>
                    <div
                        className={clsx(cls.itemStatus, {
                            [cls.itemStatusDone]: topic?.is_done,
                            [cls.itemStatusGreen]: topic?.is_done && isGreen,
                        })}
                    >
                        <TickIcon />
                    </div>
                    <span className={cls.capitalize}>{topic?.name || topic?.topics[0]?.name}</span>
                </div>
                <ArrowGoIcon className={cls.itemArrow} />
            </Link>
        </li>
    );
};
